import React from "react";

const ButtonImageQuestion = ({ question, value = "", onChange }) => {
    // console.log("ButtonImageQuestion", question, value);
    // const realValue = question.answers.find((option) => (option.value ?? option.ans_id) === value) || "";
    return (
        <div className="question ButtonImageQuestion py-4 py-lg-5">
            <div className="chat-message">
                <h4 className="m-0" dangerouslySetInnerHTML={{ __html: question.label +
                                            (question.optional !== 1 ? "" : "") }}/>
                {question.sublabel && (<p className="mb-0 mt-1" dangerouslySetInnerHTML={{ __html: question.sublabel }}/>)}
            </div>
            <div className="row justify-content-center">
                {question.answers.map((option) => {
                    // console.log("ButtonImageQuestion option", option);
                    const realValue = option.value ?? option.ans_id;
                    return (
                    <div className="col-6 col-lg px-1 pt-4" key={option.ans_id}>
                        <button
                            value={realValue}
                            className={`btn ${value === realValue ? "active" : ""}`}
                            onClick={() => onChange(realValue)}
                        >
                            <div className="bg"></div>
                            <img src={`${process.env.PUBLIC_URL}/assets/images/svg/${option.icon}`} alt="" />
                        </button>
                        <p className="m-0 text-center mt-3 mt-lg-4">{option.label}</p>
                    </div>
                    )
                })}
            </div>
        </div>
    );
};

export default ButtonImageQuestion;
